import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { logoutCognitoUser } from '../../graphql/';
import axios from 'axios';
import config from '../../aws-exports';
import API_ENDPOINTS from '../../apiEndpoints';
import { getAccessToken } from '../../library/shared';

const SignoutPage = () => {
  const [isSigningOut, setIsSigningOut] = useState(true);

  const constructLogoutUrl = (config) => {
    const cognitoDomain = config.oauth.domain;
    const clientId = config.aws_user_pools_web_client_id;
    const signoutUrl = config.oauth.redirectSignOut;
    return `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${signoutUrl}`;
  };

  useEffect(() => {
    const performSignout = async () => {
      try {
        setIsSigningOut(true);
        // Get access token for API calls
        let accessToken = getAccessToken();
        // Step 1: Call GraphQL logout to clear session in database
        try {
          console.log('Starting GraphQL logout...');
          await API.graphql(graphqlOperation(logoutCognitoUser));
          console.log('GraphQL logout completed');
        } catch (error) {
          console.log('GraphQL logout error:', error);
        }
        // Step 2: Call axios API to log out from all sessions
        if (accessToken) {
          try {
            console.log('Starting axios logout...');
            const option = {
              method: 'POST',
              url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
              headers: { Authorization: accessToken },
              data: {
                reason: 'logout from signout page',
              },
            };
            await axios(option);
            console.log('Axios logout completed');
          } catch (error) {
            console.log('Axios logout error:', error);
          }
        } else {
          console.log('No access token found, skipping axios logout');
        }

        // Step 3: Wait a moment to ensure requests are fully processed
        console.log('Waiting for requests to complete...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Step 4: Set flag to indicate we're going to Cognito logout

        // Step 5: Redirect to Cognito hosted UI logout URL
        console.log('All signout operations completed, redirecting to Cognito...');
        const logouturl = constructLogoutUrl(config);
        window.location.href = logouturl;
      } catch (error) {
        console.error('Signout error:', error);
        // Even if there's an error, still redirect to logout page
        window.location.href = '/logout';
      } finally {
        setIsSigningOut(false);
      }
    };

    performSignout();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress size={60} sx={{ mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Signing out...
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Please wait while we sign you out
      </Typography>
    </Box>
  );
};

export default SignoutPage;
